import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';

/**
 * Inline link to open date/datetime literals help (list filters, workflow field updates).
 */
export default function DateLiteralsHintLink({ onOpen, className = '' }) {
  if (typeof onOpen !== 'function') return null;

  return (
    <div
      className={`small text-muted mt-1 d-flex align-items-center gap-1 ${className}`.trim()}
    >
      <FaQuestionCircle
        className="text-primary"
        size={12}
        style={{ cursor: 'pointer' }}
        title="Date literals help"
        onClick={onOpen}
      />
      <span
        role="button"
        tabIndex={0}
        className="text-primary"
        style={{ cursor: 'pointer' }}
        onClick={onOpen}
        onKeyDown={(e) => e.key === 'Enter' && onOpen()}
      >
        Date / datetime literals and formats
      </span>
    </div>
  );
}
